<template>
    <div id="app">
        <Tab v-show="notPrivacyPage" @toggleForm='toggleForm'/>
        <keep-alive>
            <transition name="shine">
                <router-view @toggleForm='toggleForm' v-if="$route.meta.keep_alive"></router-view>
            </transition>
        </keep-alive>
        <transition name="shine">
            <router-view @toggleForm='toggleForm' v-if="!$route.meta.keep_alive"></router-view>
        </transition>
        <SideBar v-show="notPrivacyPage"/>
        <PopUp :form_msg='form_msg'/>
    </div>
</template>

<script>
import Vue from "vue";
import Tab from '../components/Tab';
import SideBar from '../components/SideBar';
import PopUp from '../components/PopUp';
import { mapState, mapActions } from 'vuex';

export default {
    name: "App",
    computed: mapState({
        common: state => state.common
    }),
    components: {
        Tab,
        SideBar,
        PopUp
    },
    data() {
        return {
            form_msg: {},
            appStyle: {},
			notPrivacyPage: true,
        };
    },
    mounted() {
        window._hmt && window._hmt.push(['_trackEvent', 'pageview', this.$route.path.slice(1)]);
    },
	created() {
		// 隐私协议页面不显示header sidebar
		if (window.location.href.includes('/page_sdk_privacy_agreement')) this.notPrivacyPage = false;
		this.$watch('$route', (to, from) => {
			// 根据不同的路由来控制header的显示与隐藏
			if (to.path === '/page_sdk_privacy_agreement') {
				this.notPrivacyPage = false;
			} else {
				this.notPrivacyPage = true;
			}
		});
	},
    methods: {
        toggleForm(flag) {
            this.form_msg = {
                show: true,
                form_type: flag
            }
        }
    }
};
</script>

<style>
    #app {
        padding-top: 60px;
    }
    /* 进出场动画 */
    .shine-enter-active, .shine-leave-active {
        transition: opacity .2s;
    }
    .shine-enter, .shine-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/containers/App.vue